import { makeFailure, makeSuccess, TResult } from "../sg-core";
import { IHprOptions, IPerson } from "./models";

const mockFirstnames = ["Matti", "Simo", "Ismo", "Helena", "Tiia", "Karoliina"];
const mockSurnames = ["Korpi", "Kannisto", "Usvasuo", "Viimanen", "Skinnar", "Lehto"];
const makeMockPhonenumber = () => Math.random().toString().slice(2, 11);

const pickRandomItem = (list: Array<any>) => {
    return list[Math.floor(Math.random() * list.length)];
};


export const mockPerson = (_1?: any, index: number = Math.random()): IPerson => {
    const firstname = pickRandomItem(mockFirstnames);
    const surname = pickRandomItem(mockSurnames);
    const fullname = surname + " " + firstname;
    const person: IPerson = {
        id: index + 1,
        fullname: fullname,
        firstname,
        surname,
        email: `${fullname}.${surname}@mail.com`,
        phone: makeMockPhonenumber(),
        company: undefined,
        certs: {},
    };
    return person;
};

export const mockPersonList = new Array(10).fill(0).map(mockPerson);

export const mockFetchPerson = async (id: IPerson["id"]) => {
    const result = mockPersonList.find((person) => id === person.id)
    return result ? makeSuccess(result) : makeFailure(Error("Failed to find person with this id"));
}

export const mockPersonSearch = async (query: string): Promise<TResult<Array<IPerson>>> => {
    const result = mockPersonList.filter((person) => person.fullname.indexOf(query) > -1);
    return makeSuccess(result)
}

export const mockHprOptions: IHprOptions = {
    fetchPersonById: mockFetchPerson,
    searchPerson: mockPersonSearch
};